var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('meter',{staticClass:"vertical",attrs:{"value":_vm.volume,"min":"20","max":"80","high":"50"}}),_c('span',{staticClass:"db-value"},[_vm._v(_vm._s(_vm.volume)+"dB")]),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }